export default __webpack_public_path__ + "static/media/awakening.cf8f3580.png";